export default "__VITE_ASSET__n7evl7iL__"